export type FormDataType = {
  email: string;
  password: string;
};

export const formDataInitialState: FormDataType = {
  email: '',
  password: '',
};
